import HeaderImg from "../../assets/header.jpeg";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

export default function GoPlayHeader() {
  return (
    <>
      <div>
        <Navbar bg="dark" variant="dark" className="justify-content-center" style={{padding: 0}}>
          <Container style={{padding: 0}}>
        <img 
          src={HeaderImg}
          className='img-fluid shadow-4'
          alt="Header"
          />
        </Container>
      </Navbar>
      </div>
    </>
  );
}
